import React, { useState, Fragment, useEffect } from "react";
import "./Add.css";
import { backend, API_URL } from "../../../config";
import { useTheme } from "@mui/material/styles";
import {
  Container,
  CssBaseline,
  Grid,
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  Divider,
  TextField,
  Button,
  Autocomplete,
  CircularProgress,
  Stack,
  useMediaQuery,
} from "@mui/material";
import {
  ShoppingCart,
  Dashboard,
  TableRows,
  PlaylistAddCheck,
  Smartphone,
  Edit,
} from "@mui/icons-material";

import { Link } from "react-router-dom";

import CardItem from "../../../components/Cards/Items/Items";
import ListItem from "../../../components/Cards/ListItems/ListItems";
import ItemDialog from "../../../components/Dialogs/Items/Items";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";

import { useDispatch, useSelector } from "react-redux";
import { initialize_cart_action } from "./../../../redux/actions/cart";
import { set_customer_action } from "./../../../redux/actions/customer";

const columnsOrderList = [
  {
    id: "upc",
    label: "UPC",
    exportable: true,
    visibility_allow_rid: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  },
  {
    id: "item_codee",
    label: "Item Code",
    exportable: true,
  },
  {
    id: "od_category_name",
    label: "Category",
    exportable: true,
  },
  {
    id: "name",
    label: "Name",
    exportable: true,
  },
  {
    id: "size",
    label: "Size",
    exportable: true,
  },
  {
    id: "display_unit_price",
    label: "Unit",
    exportable: true,
  },
  {
    id: "display_case_price",
    label: "Case",
    exportable: true,
  },
  {
    id: "combined_stock_level",
    label: "Combined Stock",
    visibility_deny_rid: [32],
    exportable: false,
  },
  {
    id: "stock_level_indicator",
    label: "Stock",
    visibility_allow_rid: [32],
    exportable: false,
  },
  {
    id: "url",
    label: "",
    exportable: false,
  },
  {
    id: "_acceptable_substitution_",
    label: "",
    exportable: false,
    visibility_allow_rid: [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29,
    ],
  },
];

export const OrdersAdd = (props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const xsWidth = useMediaQuery(theme.breakpoints.only("xs"));

  const initialStateSelectedItem = {
    id: 0,
    image: "",
    code: "",
    name: "",
    price: 0,
    count: 0,
    description: "",
    upc: "",
    location: "",
  };

  const cartStore = useSelector((state) => state.cart);
  const customerStore = useSelector((state) => state.customer);
  const currentUserStore = useSelector((state) => state.current_user);

  const [query, setQuery] = useState("");
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialStateSelectedItem);
  const [customers, setCustomers] = useState([]);
  const [companyLocations, setCompanyLocations] = useState([]);
  const [view, setView] = useState(1);
  const [orderList, setOrderList] = useState([]);
  const [orderListData, setOrderListData] = useState([]);
  const [orderListCustomer, setOrderListCustomer] = useState([]);
  const [orderListFull, setOrderListFull] = useState([]);
  const [orderListPricing, setOrderListPricing] = useState([]);
  const [orderListPricingLoaded, setOrderListPricingLoaded] = useState(false);
  const [orderListLoaded, setOrderListLoaded] = useState(false);
  const [orderListLoading, setOrderListLoading] = useState(true);
  const [orderListMapped, setOrderListMapped] = useState(false);
  const [orderListFiltered, setOrderListFiltered] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [stagedStore, setStagedStore] = useState([]);
  const [stagedStoreLoaded, setStagedStoreLoaded] = useState(false);

  const handleCustomerChange = (e, v) => {
    if (!Object.keys(cartStore).includes("" + v.id)) {
      dispatch(initialize_cart_action([], v));
    }

    dispatch(set_customer_action(v));

    setStagedStore([]);
    setOrderList([]);
    setOrderListData([]);
    setOrderListCustomer([]);
    setOrderListFull([]);
    setOrderListPricing([]);
    setOrderListPricingLoaded(false);
    setOrderListLoaded(false);
    setOrderListLoading(true);
    setOrderListMapped(false);
    setProductsLoaded(false);
    setStagedStoreLoaded(false);
  };

  const handleQuery = (e) => {
    const { value } = e.target;
    if (value !== "" && value.length < 3) return;
    setQuery(value);
  };

  const handleClickCardView = () => {
    setView(1);
  };

  const handleClickTableView = () => {
    setView(2);
  };

  const handleClickCondensedView = () => {
    setView(3);
  };

  useEffect(() => {
    const companyLocationsGet = async () => {
      await backend
        .get(`${API_URL}companylocations?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.filter((item) => item.active);
          setCompanyLocations(dataMap);
        });
    };

    const customersGet = async () => {
      await backend.get(`${API_URL}users?no_page=1`).then(({ data }) => {
        const dataMap = data
          .filter((item) => item.is_active)
          .map((item) => {
            const customerCompanyLocations = item.company
              ? companyLocations.filter(
                  (clItem) => clItem.company_id === item.company,
                )
              : [];

            const customerCompanyLocationsId = customerCompanyLocations.map(
              (clItem) => clItem.id,
            );

            return {
              id: item.id,
              name: item.username,
              company_id: item.company,
              company_location: customerCompanyLocationsId,
              company_location_data: customerCompanyLocations,
            };
          });

        if (dataMap.length === 1) {
          const customerDefault = dataMap[0];

          if (!Object.keys(cartStore).includes("" + customerDefault.id)) {
            dispatch(initialize_cart_action([], customerDefault));
          }

          dispatch(set_customer_action(customerDefault));
        }

        setCustomers(dataMap);
      });
    };

    if (!companyLocations.length) {
      companyLocationsGet();
    }

    if (companyLocations.length && !customers.length) {
      customersGet();
    }
  }, [cartStore, companyLocations, customers, dispatch]);

  useEffect(() => {
    const getOrderList = async () => {
      if (customerStore.company_id) {
        await backend
          .get(
            `${API_URL}orderlists?no_page=1&visible=True&company_id=${customerStore.company_id}`,
          )
          .then(({ data }) => {
            setOrderListFull(data);
            setOrderListLoaded(true);
            setOrderListLoading(false);
          });
      } else {
        setOrderListLoaded(true);
        setOrderListLoading(false);
      }
    };

    if (!orderListFull.length && !orderListLoaded && customerStore) {
      getOrderList();
    }
  }, [orderListFull, orderListLoaded, customerStore]);

  useEffect(() => {
    const getStagedStore = async () => {
      const customerCLocation = customerStore.company_location
        ? customerStore.company_location[0]
        : null;

      await backend
        .get(
          `${API_URL}sharedcartitems?no_page=1&company_location_id=${customerCLocation}`,
        )
        .then(({ data }) => {
          setStagedStore(data);
          setStagedStoreLoaded(true);
        });
    };

    if (customerStore && !stagedStore.length && !stagedStoreLoaded) {
      getStagedStore();
    }
  }, [stagedStore, stagedStoreLoaded, customerStore]);

  useEffect(() => {
    const getOrderListPricing = () => {
      let orderListPricingArray = [];

      Promise.all(
        orderListFull.map(async (item) => {
          await backend
            .get(`${API_URL}orderlistprices?no_page=1&order_list=${item.id}`)
            .then(({ data }) => {
              orderListPricingArray = [...orderListPricingArray, ...data];
            });
        }),
      ).then(() => {
        setOrderListPricing(orderListPricingArray);
        setOrderListPricingLoaded(true);
      });
    };

    if (orderListFull.length && orderListLoaded && !orderListPricingLoaded) {
      getOrderListPricing();
    }
  }, [orderListFull, orderListLoaded, orderListPricingLoaded]);

  useEffect(() => {
    const getOrderListProducts = () => {
      let productsArray = [];

      Promise.all(
        orderListFull.map(async (item) => {
          await backend
            .get(
              `${API_URL}products?include_inactive=true&include_nonprimary=true&no_page=1&order_list=${item.id}`,
            )
            .then(({ data }) => {
              const productsMap = data.map((item) => ({
                ...item,
                unit_in_cart: 0,
                case_in_cart: 0,
                added_in_cart: false,
                added_through_sub: false,
              }));

              productsArray = [...productsArray, ...productsMap];
            });
        }),
      ).then(() => {
        setProducts(productsArray);
        setProductsLoaded(true);
      });
    };

    if (orderListFull.length && orderListLoaded && !productsLoaded) {
      getOrderListProducts();
    }
  }, [orderListFull, orderListLoaded, productsLoaded]);

  useEffect(() => {
    const orderListMapping = () => {
      let customerOrderListRows = [];
      const customerOrderList = orderListFull.map((item) => {
        const categoriesDisplay = item.categories.map((catItem) => {
          const rowsMapped = catItem.rows.map((rowItem) => {
            const productObj = products.find(
              (product) => product.upc === rowItem.product_id,
            );
            const productPricingObj = orderListPricing.find(
              (product) => product.upc === rowItem.product_id,
            );

            return {
              ...rowItem,
              ...productObj,
              ...productPricingObj,
              od_category_name: catItem.category_name,
              item_codee: productObj ? productObj.item_code.item_code : "",
            };
          });

          customerOrderListRows = [...customerOrderListRows, ...rowsMapped];

          return { ...catItem, rows: rowsMapped };
        });

        return {
          ...item,
          categories: categoriesDisplay,
        };
      });

      if (!orderListCustomer.length) {
        setOrderListCustomer(customerOrderList);
      }

      setOrderList(customerOrderList);
      setOrderListData(customerOrderListRows);
      setOrderListMapped(true);
      setOrderListFiltered(false);
    };

    if (orderListPricingLoaded && productsLoaded && !orderListMapped) {
      orderListMapping();
    }
  }, [
    orderListCustomer,
    orderListFull,
    orderListMapped,
    orderListPricing,
    orderListPricingLoaded,
    products,
    productsLoaded,
  ]);

  useEffect(() => {
    const orderListFiltering = () => {
      if (orderListFiltered && query === "") {
        setOrderList(orderListCustomer);
        setOrderListFiltered(true);
      } else {
        const customerOrderListFiltered = orderListCustomer
          .map((item) => {
            let categoriesArray = item.categories
              .map((category) => {
                let rowsArray = category.rows.filter((row) => {
                  if (!row.hasOwnProperty("name")) return false;

                  return (
                    row.name
                      .toLowerCase()
                      .indexOf(query.trim().toLowerCase()) !== -1 ||
                    (row.item_code
                      ? row.item_code.item_code
                          .toLowerCase()
                          .indexOf(query.trim().toLowerCase()) !== -1
                      : false)
                  );
                });

                return { ...category, rows: rowsArray };
              })
              .filter((category) => category.rows.length);

            return { ...item, categories: categoriesArray };
          })
          .filter((item) => item.categories.length);

        setOrderList(customerOrderListFiltered);
        setOrderListFiltered(true);
      }
    };

    orderListFiltering();
  }, [orderListCustomer, orderListFiltered, query]);

  useEffect(() => {
    if (xsWidth) setView(3);
  }, [xsWidth]);

  return (
    <Fragment>
      <CssBaseline />
      <Container
        maxWidth="lg"
        className="container"
        style={{ minHeight: "80vh" }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          style={{ paddingBottom: xsWidth ? 100 : "inherit" }}
        >
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" component="div">
              Create Order
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            Select a customer
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel shrink id="customer-label">
                Customer
              </InputLabel>
              <Autocomplete
                fullWidth
                disablePortal
                disableClearable
                name="customer"
                options={customers}
                getOptionLabel={(option) =>
                  option !== null ? `${option.name}` : ""
                }
                renderInput={(params) => (
                  <TextField {...params} variant="standard" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={customerStore}
                onChange={(e, value) => handleCustomerChange(e, value)}
              />
            </FormControl>
          </Grid>
          {customerStore !== null ? (
            <>
              <Grid item xs={"auto"} sm={"auto"}>
                <Stack
                  direction={xsWidth ? "column" : "row"}
                  spacing={1}
                  className="cart-button"
                >
                  {cartStore[customerStore.id] ? (
                    cartStore[customerStore.id].products.length ? (
                      <Link to="/cart" style={{ textDecoration: "none" }}>
                        <Button
                          variant="contained"
                          startIcon={<ShoppingCart />}
                          style={{ backgroundColor: "green" }}
                        >
                          Cart
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="contained"
                        startIcon={<ShoppingCart />}
                        disabled={!cartStore[customerStore.id].products.length}
                      >
                        Cart
                      </Button>
                    )
                  ) : (
                    <></>
                  )}
                  {stagedStore.length ? (
                    <Link
                      to="/cart?stagedOrder=1"
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<PlaylistAddCheck />}
                        style={{ backgroundColor: "#0288d1" }}
                      >
                        Staged Order
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      variant="contained"
                      startIcon={<PlaylistAddCheck />}
                      disabled={!stagedStore.length}
                    >
                      Staged Order
                    </Button>
                  )}
                </Stack>
              </Grid>
              <Grid item xs={true} sm={true}>
                <span style={{ marginLeft: theme.spacing(2) }}>
                  {`Total: $${
                    cartStore[customerStore.id] &&
                    cartStore[customerStore.id].total
                      ? cartStore[customerStore.id].total.toFixed(2)
                      : 0
                  }`}
                </span>
              </Grid>
              <Grid item xs={"auto"} sm={"auto"}>
                <IconButton onClick={handleClickCardView}>
                  <Dashboard className={view === 1 ? "activeView" : ""} />
                </IconButton>
                <IconButton onClick={handleClickTableView}>
                  <TableRows className={view === 2 ? "activeView" : ""} />
                </IconButton>
                <IconButton onClick={handleClickCondensedView}>
                  <Smartphone className={view === 3 ? "activeView" : ""} />
                </IconButton>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Divider />
              </Grid>
              {view === 1 ? (
                <>
                  {productsLoaded ? (
                    <>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          fullWidth
                          autoFocus
                          size="small"
                          id="search-text"
                          variant="outlined"
                          label="Search "
                          name="search-text"
                          defaultValue={query}
                          onChange={handleQuery}
                        />
                      </Grid>
                      {orderListLoading ||
                      (orderListFull.length && !orderListMapped) ? (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          style={{ textAlign: "center" }}
                        >
                          <div>Loading Order Guide ...</div>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {orderList.length &&
                      (orderListMapped || orderListFiltered) ? (
                        orderList.map((olItem) =>
                          olItem.categories.map((category, catIndex) => (
                            <Grid item xs={12} key={`cat-${catIndex}`}>
                              <div
                                style={{
                                  fontSize: "135%",
                                  fontWeight: "bold",
                                  textTransform: "uppercase",
                                  marginBottom: 10,
                                }}
                              >
                                {category.category_name}
                                {currentUserStore &&
                                currentUserStore.role_id < 12 ? (
                                  <Link
                                    to={`/customer/${olItem.company_location}?orderlist=1`}
                                    style={{
                                      textDecoration: "none",
                                      marginLeft: 8,
                                    }}
                                  >
                                    <IconButton>
                                      <Edit />
                                    </IconButton>
                                  </Link>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <Grid container spacing={3} textAlign="center">
                                {category.rows.map((item, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    key={`cat-${catIndex}-item-${index}-${item.upc}`}
                                  >
                                    <CardItem
                                      {...props}
                                      type={1}
                                      data={item}
                                      cartInfo={
                                        customerStore !== null
                                          ? cartStore[customerStore.id] &&
                                            cartStore[
                                              customerStore.id
                                            ].products.find(
                                              (product) =>
                                                product.upc === item.upc,
                                            )
                                          : undefined
                                      }
                                      setSelectedItem={setSelectedItem}
                                      setOpenItemDialog={setOpenItemDialog}
                                      storeAddons={true}
                                      reloadable={true}
                                      className={`${index === 0 ? "card-item" : undefined}`}
                                    />
                                  </Grid>
                                ))}
                                {!category.rows.length ? (
                                  <>
                                    <Grid item xs={12} sm={12}>
                                      There are no products assigned to this
                                      category
                                    </Grid>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Grid>
                            </Grid>
                          )),
                        )
                      ) : (
                        <>
                          {!orderListLoading && !orderListFull.length ? (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              style={{ textAlign: "center" }}
                            >
                              <div>
                                There are no Order Guide assigned to this
                                customer
                              </div>
                            </Grid>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                      <CircularProgress />
                      <div>Loading products...</div>
                    </Grid>
                  )}
                </>
              ) : view === 2 ? (
                <>
                  {orderListData.length ? (
                    <Grid item xs={12}>
                      <InfiniteTable
                        {...props}
                        apiep={null}
                        columns={columnsOrderList}
                        data={orderListData}
                        dataMapByColumn="id"
                        deletable={false}
                        editable={true}
                        filterable={true}
                        label="Order Guide"
                        fetchingModal={null}
                        storeAddons={true}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                      <div>
                        {orderListLoading ||
                        (orderListFull.length && !orderListMapped)
                          ? `Loading Order Guide ...`
                          : `There are no Order Guide assigned to this customer`}
                      </div>
                    </Grid>
                  )}
                </>
              ) : (
                <>
                  {productsLoaded ? (
                    <>
                      {orderListLoading ||
                      (orderListFull.length && !orderListMapped) ? (
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                          <div>Loading Order Guide ...</div>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {orderList.length &&
                      (orderListMapped || orderListFiltered) ? (
                        orderList.map((olItem) =>
                          olItem.categories.map((category, catIndex) => (
                            <Grid
                              item
                              xs={12}
                              key={`condensed-cat-${catIndex}`}
                            >
                              <div
                                style={{
                                  fontSize: "135%",
                                  fontWeight: "bold",
                                  textTransform: "uppercase",
                                  marginBottom: 10,
                                }}
                              >
                                {category.category_name}
                              </div>
                              <Grid container spacing={1} textAlign="center">
                                {category.rows.map((item, index) => (
                                  <Fragment
                                    key={`condensed-cat-${catIndex}-item-${index}`}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      className={`${
                                        olItem.active === false
                                          ? "iInactive"
                                          : ""
                                      }`}
                                    >
                                      <ListItem
                                        type={1}
                                        data={item}
                                        cartInfo={
                                          customerStore !== null
                                            ? cartStore[
                                                customerStore.id
                                              ].products.find(
                                                (product) =>
                                                  product.upc === item.upc,
                                              )
                                            : undefined
                                        }
                                        setSelectedItem={setSelectedItem}
                                        setOpenItemDialog={setOpenItemDialog}
                                        storeAddons={true}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Divider />
                                    </Grid>
                                  </Fragment>
                                ))}
                                {!category.rows.length ? (
                                  <>
                                    <Grid item xs={12} sm={12}>
                                      There are no products assigned to this
                                      category
                                    </Grid>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Grid>
                            </Grid>
                          )),
                        )
                      ) : (
                        <>
                          {!orderListLoading && !orderListFull.length ? (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              style={{ textAlign: "center" }}
                            >
                              <div>
                                There are no Order Guide assigned to this
                                customer
                              </div>
                            </Grid>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                      <CircularProgress />
                      <div>Loading products...</div>
                    </Grid>
                  )}
                </>
              )}
              <div
                style={{
                  position: "fixed",
                  textAlign: "right",
                  bottom: 10,
                  right: 10,
                }}
              >
                <Stack direction={xsWidth ? "column" : "row"} spacing={1}>
                  {cartStore[customerStore.id] ? (
                    cartStore[customerStore.id].products.length ? (
                      <Link to="/cart" style={{ textDecoration: "none" }}>
                        <Button
                          variant="contained"
                          startIcon={<ShoppingCart />}
                          style={{ backgroundColor: "green" }}
                        >
                          Cart
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="contained"
                        startIcon={<ShoppingCart />}
                        disabled={!cartStore[customerStore.id].products.length}
                      >
                        Cart
                      </Button>
                    )
                  ) : (
                    <></>
                  )}
                  {stagedStore.length ? (
                    <Link
                      to="/cart?stagedOrder=1"
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<PlaylistAddCheck />}
                        style={{ backgroundColor: "#0288d1" }}
                      >
                        Staged Order
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      variant="contained"
                      startIcon={<PlaylistAddCheck />}
                      disabled={!stagedStore.length}
                    >
                      Staged Order
                    </Button>
                  )}
                </Stack>
              </div>
            </>
          ) : (
            <></>
          )}
        </Grid>
      </Container>
      <ItemDialog
        data={selectedItem}
        openItemDialog={openItemDialog}
        setOpenItemDialog={setOpenItemDialog}
      />
    </Fragment>
  );
};

export default OrdersAdd;
